"use client";

import React from "react";

/**
 * Wrapper that applies primary text color to icon children. Theme encapsulated.
 */
export default function AgentPrimaryIcon({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <span className={`text-primary ${className ?? ""}`}>{children}</span>;
}
